import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import { routes } from '../../../redux/api/routes';
/* Actions */
import {
	getInvoicePDF,
	savePreviousReturnAndCreditDetails,
	getOrderDetails,
} from '../../../redux/actions';

class OrderDetails extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orderDetails: null,
			showGenericOverlayDialog: false,
			showGenericMcodeDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: ''
		}
		this.updateStateWithOrderDetails = this.updateStateWithOrderDetails.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.prepareListOfAttributeFromItems = this.prepareListOfAttributeFromItems.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();
		const {orderDetails} = 	self.props.state.order;	
		if(orderDetails && accountNumber) {
			if(orderDetails.responseObject.originalOrderNumber == null){
				self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
			}else{
				self.props.getOrderDetails('orderNumber='+orderDetails.responseObject.originalOrderNumber+'&requestType=getOrderDetails&accountNumber='+accountNumber, (response) => {
					if(response){
					self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
					}						
			})}
		} else {
			browserHistory.push('/manageorders');
		}
	}

	updateStateWithOrderDetails(response) {
		var self = this;
		if(!response.status) {
			self.setState({
				errorMessage: response.responseMessage
			});
		} else {
			//filter all products which cancelled.
			response.responseObject.items = _.filter(response.responseObject.items, (item) => {
				return item.lineStatus.toLowerCase() !== 'cancelled';
			});
			const { selectedPriceSource } = self.props.state.user;
			let subTotal = 0.00;
			let orderTax = 0.00;
			let tariffSurcharge = 0.00;
			try {
				response.responseObject.items.forEach((item, index) => {
					let extendedPrice = null;
					if(item.price && item.quantity) {
						extendedPrice = parseFloat(item.price) * parseInt(item.quantity, 10);
						extendedPrice = parseFloat(extendedPrice).toFixed(2);
						subTotal += parseFloat(extendedPrice);
					}
					item.extendedPrice = extendedPrice;
					if(!item.agreementNumber) {
						item.agreementName = selectedPriceSource.AGREEMENT_NAME;
					}
					orderTax += parseFloat(item.tax);
					// check for modifier chargeTypeCode: "TARIFFCN"
					item.modifiers = item.modifiers && item.modifiers.length ? item.modifiers.filter(itm => itm.chargeTypeCode === 'TARIFFCN') : [];
					item.modifiers.forEach(itm => {
						itm.totalAmount = parseFloat(itm.adjustedAmount * item.quantity).toFixed(2);
						tariffSurcharge += parseFloat(itm.adjustedAmount * item.quantity);
					});
				});
				subTotal = parseFloat(subTotal).toFixed(2);
				orderTax = parseFloat(orderTax).toFixed(2);
				tariffSurcharge = parseFloat(tariffSurcharge).toFixed(2);
				response.responseObject.subTotal = subTotal;
				response.responseObject.orderTax = orderTax;
				response.responseObject.tariffSurcharge = tariffSurcharge;
				response.responseObject.orderTotal = parseFloat(parseFloat(subTotal) + parseFloat(orderTax) + parseFloat(tariffSurcharge)).toFixed(2);

				const { deliveryMethod } = response.responseObject;
				response.responseObject.orderShippingDetailsDates = self.props.getOrderShippingDetailsDates(deliveryMethod, self.props.state.order.orderShippingDetails);
			} catch(err) {
				self.setState({
					errorMessage: err.message
				});
			} finally {
				self.setState({
					orderDetails: response.responseObject
				});
			}
		}
	}

	getInvoiceDocument(invoiceNumber, event) {
		event && event.preventDefault();
		const self = this;
		// second param says whether it needs to be saved into store
		const param = `requestType=getInvoicePDF&invoiceNumber=${invoiceNumber}&accountNumber=${self.props.getSelectedAccountNumber()}`;
		self.props.getInvoicePDF(param, response => {
			if(response.status) {
				if(response.responseObject) {
					window.open(response.responseObject);
				} else {
					// No invoice document found
					self.setState({
						genericDialogHeading: "Invoice",
						genericDialogText: "No invoice document found.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}

	prepareListOfAttributeFromItems() {
		const { orderShippingDetails } = this.props.state.order;
		let orderLineShippingDetails = orderShippingDetails && orderShippingDetails.responseObject && orderShippingDetails.responseObject.orderdetoutrec;
		orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails[0] && orderLineShippingDetails[0].linedetailsrec;
		orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails.value && orderLineShippingDetails.value.linedetails;
		const shipmentNumbers = [];
		const vehicleNumbers = [];
		(orderLineShippingDetails || []).forEach(item => {
			if (item.deliverydetailsrec && item.deliverydetailsrec.value && item.deliverydetailsrec.value.deliverydetails && item.deliverydetailsrec.value.deliverydetails[0] &&
				item.deliverydetailsrec.value.deliverydetails[0].tripdetailsrec && item.deliverydetailsrec.value.deliverydetails[0].tripdetailsrec.value && item.deliverydetailsrec.value.deliverydetails[0].tripdetailsrec.value.tripdetails
			) {
				const data = item.deliverydetailsrec.value.deliverydetails[0].tripdetailsrec.value.tripdetails;
				data.forEach(itm => {
					if (itm.planname && itm.planname.value) {
						shipmentNumbers.push(itm.planname.value);
					}
					if (itm.vehiclenumber && itm.vehiclenumber.value) {
						vehicleNumbers.push(itm.vehiclenumber.value);
					}
				});

			}
		});
		return {
			shipmentNumber: _.uniq(shipmentNumbers).join(', '),
			vehicleNumber: _.uniq(vehicleNumbers).join(', ')
		};
	}

	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}

	handleShowServiceDescription(serviceDetails, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			genericDialogHeading: "Service",
            genericDialogText: (serviceDetails.item || serviceDetails.internalItem) + " - " + serviceDetails.itemDescription,
            modalButtons: 'ok'
		}, () => {
			self.handleDialog("GenericOverlayDialog", true);
		});
	}

	handleReturnLinesDetails(returnLines, orderHeader, event) {
		event && event.preventDefault();
		const self = this;
		let orderNum = orderHeader.orderNumber;
		self.props.savePreviousReturnAndCreditDetails({
			orderNum,
			returnLines
		});
		//self.props.saveRequestReturnList(self.state.requestReturnList);
		browserHistory.push('/previousreturnandcredit');
	}

    render() {
		const self = this;
		const  { orderDetails } = self.state;
		const isPricingAccess = self.props.isResponsibilityExists("Price");
		let eta = '';
		let orderPoints = 0.00;
		let totalQuantity = 0;
		if(orderDetails && orderDetails.items && orderDetails.items.length > 0) {
			if(orderDetails.orderStatus === 'BOOKED') {
				if(orderDetails.items[0].suggestedShipDate) {
					eta = self.props.formatDate(orderDetails.items[0].suggestedShipDate, 'MM/DD/YY');
				} else if(orderDetails.items[0].scheduledShipDate) {
					eta = self.props.formatDate(orderDetails.items[0].scheduledShipDate, 'MM/DD/YY');
				}
			}
			orderDetails.items.forEach(item => {
				if(item.pointValue) {
					orderPoints += parseFloat(item.pointValue) * item.quantity;
				}
				if(item.quantity &&
					self.props.checkItemIsServiceOrNot(item.item) !== 'service' &&
					self.props.getItemTypeByName(item.item) !== 'S'
				) {
					totalQuantity += parseInt(item.quantity, 10);
				}
			});
			orderPoints = parseFloat(orderPoints).toFixed(2);
		}
		const details = self.prepareListOfAttributeFromItems();
		let trackingDetails =[];
		const list = this.props.state.order.trackingDetails
		list && list.map(itemList=>{
		 	if(orderDetails && itemList.orderNumber == orderDetails.orderNumber){
		 		trackingDetails.push(itemList.deliveryStatus.P_DELIVERY_STATUS_INFO_TBL_ITEMS)
			}
		})
			const totalsByLineNo = {};
			orderDetails && orderDetails.items && orderDetails.items.forEach(item => {
			if (!totalsByLineNo[item.lineNo]) {
				totalsByLineNo[item.lineNo] = { totalPrice: 0, totalExtendedPrice: 0 };
			}
			totalsByLineNo[item.lineNo].totalPrice += parseFloat(item.price) || 0;
			totalsByLineNo[item.lineNo].totalExtendedPrice += parseFloat(item.extendedPrice) || 0;
			});
			const updatedItems = orderDetails && orderDetails.items.map(item => {
			if (item.itemType === "MODEL") {
				const totals = totalsByLineNo[item.lineNo];
				return {
				...item,
				price: totals.totalPrice,
				extendedPrice: totals.totalExtendedPrice
				};
			}
			return item;
			});
        return (
			<div>
				<div className="push">
					<h1 className="pageTitle">Order Details</h1>
				</div>
				{this.state.errorMessage && <p className="red bold">{this.state.errorMessage}</p>}
				<div className="push">
					<h2>CSO (Order number): {orderDetails && orderDetails.orderNumber}</h2>
					{orderDetails && orderDetails.referenceNumber && orderDetails.referenceNumber.indexOf("CTN") === 0 &&
						<h3>Order Reference #: {orderDetails.referenceNumber}</h3>
					}
					<h3>Account #: {orderDetails && orderDetails.accountNumber}</h3>
				</div>
				{orderDetails &&
					<div>
						<h2 style={{borderBottom: '1px solid #000'}}><span style={{fontSize: '1.4em'}}>1</span><sup>st</sup> Delivery</h2>
						<div className="push orderReviewColumns columns threeColumns">
							<div className="orderReviewColumn column column1">
								<p>
									<strong>Status</strong>: {orderDetails.orderStatus}<br />
									<strong>Warehouse</strong>: {orderDetails.warehouseName}<br />
									<strong>Order Date</strong>: {orderDetails.orderDate && this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br />
									{orderDetails.createdBy && <span><strong>Order started by</strong>: {orderDetails.createdBy}<br /></span>}
									<strong>P.O.#</strong>: {orderDetails.poNumber}<br /><br />
									<span>
										{orderDetails.billingReference && orderDetails.billingReference.map((it, id) => {
											if(!it.name && !it.value) return null;
											return <span key={id}><strong>{it.name}</strong>: {it.value}<br/></span>
										})}
									</span>
								</p>
								{orderDetails.requestedDeliveryDate && <p><strong>Requested Delivery Date</strong>:  {orderDetails.requestedDeliveryDate && this.props.formatDate(orderDetails.requestedDeliveryDate, 'MM/DD/YY')}</p>}
								{ trackingDetails[0] && trackingDetails[0].map((track, index) => {
									let trackingUrl = routes.FED_EX.replace("<TRACKING_NUMBER>",track.TRACKING_NUMBER);
									return  track.TRACKING_NUMBER && <span key={index} style={{color:"red"}}><strong>Tracking #:</strong> <a href={trackingUrl} target="_blank">{track.TRACKING_NUMBER}</a><br /></span>
								})}
								{orderDetails.orderShippingDetailsDates && orderDetails.orderShippingDetailsDates.length > 0 && <p className="bold red">
									{orderDetails.orderShippingDetailsDates && orderDetails.orderShippingDetailsDates.map((item, index) => {
										if(orderDetails.deliveryMethod.startsWith("ADC") || orderDetails.deliveryMethod === "Meet Truck" || orderDetails.deliveryMethod === "Factory Direct Truckload" || orderDetails.deliveryMethod === "SDS Will Call"){
											return <span key={index}>Delivery Appt: {item}<br/></span>
										}else{
											return <span key={index}>{""}</span>
										}
									})}
								</p>}
							</div>
							<div className="orderReviewColumn column column2">
								{orderDetails.shippingAddress && <p>
									<strong>Ship to</strong>:<br />
									{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
									<span>{orderDetails.shippingAddress.address1}<br /></span>
									{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
									{orderDetails.shippingAddress.address3 && <span>{orderDetails.shippingAddress.address3}<br /></span>}
									<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
									{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
								</p>}
								<p>
									{orderDetails.deliveryPhone && <span><strong>Delivery Phone</strong>:  {this.props.normalizePhoneNumber(orderDetails.deliveryPhone)}<br /></span>}
									{orderDetails.deliveryInstructions && <span><strong>Shipping Instructions</strong>:  {orderDetails.deliveryInstructions}<br /></span>}
								</p>
							</div>
							<div className="orderReviewColumn column column3">
								{orderDetails.billingAddress && <p>
									<strong>Bill to</strong>:<br />
									{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
									<span>{orderDetails.billingAddress.address1}<br /></span>
									{orderDetails.billingAddress.address2 && <span>{orderDetails.billingAddress.address2}<br /></span>}
									<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
									{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
								</p>}
								<p>
									{orderDetails.deliveryTerms && <span><strong>Delivery Terms</strong>:  {orderDetails.deliveryTerms}<br /></span>}
									{orderDetails.deliveryMethod && <span><strong>Shipping Method</strong>:  {orderDetails.deliveryMethod}<br /></span>}
								</p>
								{details && <p>
									{details.shipmentNumber && <span><strong>Shipment #</strong>: {details.shipmentNumber}<br /></span>}
									{details.vehicleNumber && <span><strong>Vehicle #</strong>: {details.vehicleNumber}</span>}
								</p>}
							</div>
						</div>
						<table className="orderReviewTable dataTableType2 noRowBorders milktoast">
							<thead>
								<tr>
									<th className="priceSource">Sales Agreement</th>
									<th>Invoice</th>
									<th>PO#</th>
									<th>Pricing Date</th>
									<th>Terms</th>
									<th className="returnCredits">Returns/<br />Credits</th>
									<th className='productNew'>Product</th>
									<th className="quantity" style={{textAlign: 'center'}}>Quantity</th>
									{isPricingAccess && <th className="price" style={{textAlign: 'right'}}>Price<br /><span className="unbold">(Each)</span></th>}
									{isPricingAccess && <th className="extendedPrice" style={{textAlign: 'right'}}>Extended<br/>Price</th>}
								</tr>
								<tr>
									<th className="toast" colSpan={9}></th>
								</tr>
							</thead>
							<tbody>
								{updatedItems.filter(item => item.itemType !== "OPTION").map((item, index) => {
									return [
										<tr key={index} className={`${item.holdType.indexOf('Declining Balance') !== -1 ? 'red' : ''}`}>
											<td className="priceSource">{item.agreementName}</td>
											<td><a href="" onClick={this.getInvoiceDocument.bind(this, item.invoiceNumber)}>{item.invoiceNumber}</a></td>
											<td>{item.poNumber}</td>
											<td>{this.props.formatDate(item.pricingDate, 'MM/DD/YY')}</td>
											<td>{item.paymentTerms}</td>
											{item.returnLines && item.returnLines.length > 0?<td><a href="#" onClick={this.handleReturnLinesDetails.bind(this, item.returnLines, orderDetails)}>View</a></td>:<a href="#"></a>}
											<td>
											{(() => {
												const excludedKeywords = [
												"DELIVERY",
												"UNCRATE",
												"1-YR",
												"2-YR",
												"4-YR",
												"SMALL PACKAGE",
												"HANDLING",
												"FREIGHT",
												];

												const shouldExcludeLink = excludedKeywords.some((keyword) =>
												(item.item || item.internalItem || "").toUpperCase().includes(keyword)
												);

												if (shouldExcludeLink) {
												return <span className="sku">{item.internalItem || item.item}</span>;
												}

												if (orderDetails.redirectFrom === "manageorder") {
												return self.isMService(item.item) ? (
													<a className="sku" href="" onClick={this.handleShowServiceDescription.bind(this, item)}>
													{item.internalItem || item.item}
													</a>
												) : (
													<a
													className="sku"
													href={`/product-specs/product-number/${item.item}`}
													target="_blank"
													>
													{item.internalItem || item.item}
													</a>
												);
												}
												return self.isMService(item.item) ? (
													<a className="sku" href=""  onClick={this.handleShowServiceDescription.bind(this, item)}>
														{item.item}
													</a>
													) : (
													<a
														className="sku"
														href={`/product-specs/product-number/${item.item}`}
														target="_blank"
													>
														{item.item}
													</a>
													);
												})()}
											</td>
											<td className="quantity" style={{textAlign: 'center'}}>{item.quantity}</td>
											{isPricingAccess && <td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(item.price, 0, ".", ",", false, "$")}</td>}
											{isPricingAccess && <td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(item.extendedPrice, 0, ".", ",", false, "$")}</td>}
										</tr>,
										item.modifiers && item.modifiers.length
										? item.modifiers.map((it, id) => {
											return <tr key={id}>
												<td className="priceSource"></td>
												<td></td>
												<td></td>
												<td></td>
												<td></td>
												<td>{it.modifierName}<br/><br/></td>
												<td className="quantity" style={{textAlign: 'center'}}>{item.quantity}</td>
												{isPricingAccess && <td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(it.adjustedAmount, 0, ".", ",", false, "$")}</td>}
												{isPricingAccess && <td className="extendedPrice" style={{textAlign: 'right'}}>{this.props.formatMoney(it.totalAmount, 0, ".", ",", false, "$")}</td>}
											</tr>
										})
										: null
									]
								})}
							</tbody>
					        <tfoot>
								<tr>
									<td colSpan={7}>Total Products</td>
									<td className="quantity" style={{textAlign: 'center'}}>{totalQuantity}</td>
									{isPricingAccess && <td>&nbsp;</td>}
									{isPricingAccess && <td className="extendedPrice" style={{textAlign: 'right'}}></td>}
								</tr>
					        </tfoot>
			      		</table>
						<div className="orderReviewPoints">
							<p className="netOrderPoints">
								<strong>Order Points:</strong> {orderPoints}
							</p>
						</div>
						{isPricingAccess && <table className="subtotalTable orderReviewSubtotalTable">
							<tbody>
								<tr className="subtotal">
									<td>Subtotal:</td>
									<td className="price" style={{textAlign: 'right'}}>{orderDetails.subTotal && this.props.formatMoney(orderDetails.subTotal, 0, ".", ",", false, "$")}</td>
								</tr>
								{orderDetails.tariffSurcharge && <tr className="tax">
									<td>Tariff Surcharge:</td>
									<td className="price" style={{textAlign: 'right'}}>{this.props.formatMoney(orderDetails.tariffSurcharge, 0, ".", ",", false, "$")}</td>
								</tr>}
								<tr className="tax">
									<td>Order Tax:</td>
									<td className="price" style={{textAlign: 'right'}}>{orderDetails.orderTax && this.props.formatMoney(orderDetails.orderTax, 0, ".", ",", false, "$")}</td>
								</tr>
								<tr className="total">
									<td>Order Total:</td>
									<td className="price" style={{textAlign: 'right'}}>{orderDetails.orderTotal && this.props.formatMoney(orderDetails.orderTotal, 0, ".", ",", false, "$")}</td>
								</tr>
							</tbody>
						</table>}
						<div className="clearfix" />
					</div>
				}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getInvoicePDF: (queryStringParams, callback) => dispatch(getInvoicePDF(queryStringParams, callback)),
	savePreviousReturnAndCreditDetails: (data) => dispatch(savePreviousReturnAndCreditDetails(data)),
	getOrderDetails: (queryStringParams, callback, saveToStore = true, isPart = false) => dispatch(getOrderDetails(queryStringParams, callback, saveToStore, isPart)),
});

OrderDetails = connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
export default OrderDetails;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/orderDetails.js